import React from 'react'

const RewardEditTitle = ({ record }) => (
  <span>{record.name ? `${record.name}` : 'Reward'}</span>
)

export default RewardEditTitle
